import makeTable from '../../components/makeTable.jsx';

export const IssueTable = makeTable([
  ['Issue', 85],
  ['Issue count', 15],
]);
